<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="StatisticsOverview")
    h1.title Buchungsübersicht
    .sub-headline Hier können Sie alle Mietobjektstatistiken sehen.
    
    .calendar-config.margin-top      
      b-field(group)
        b-field(label-position="on-border" label="Mietobjekte")
          b-select(v-model="rentObjectId")
            option(v-for="rentObject in rentObjects.filter(r => r.rentObjectType.isBookable)" :value="rentObject.id") {{rentObject.name}}
        .spacer.md
        b-field(label-position="on-border" label="Jahr")
          b-select(v-model="year")
            option(v-for="y in currentYear+10-rootYear") {{rootYear + y}}
        .spacer.md
        b-field(label-position="on-border" label="Monat")
          b-select(v-model="month")
            option(value="-1") Gesamt
            option(value="0") Januar
            option(value="1") Februar
            option(value="2") März
            option(value="3") April
            option(value="4") Mai
            option(value="5") Juni
            option(value="6") Juli
            option(value="7") August
            option(value="8") September
            option(value="9") Oktober
            option(value="10") November
            option(value="11") Dezember
        template(v-if="rentObjectId")
          .spacer.md
          b-button(type="is-light" icon-left="file-excel" @click="createExcel()" ) Mietobjektstatistik-Excel herunterladen

    .card.margin-top
      .main
        b-table(:data="rentObjectData.contracts"
                default-sort-direction="asc"
                default-sort="startDate"
                hoverable)
          b-table-column(label='Pos.' v-slot="props")
            | {{props.index + 1}}
          b-table-column(field="contractId" label='V-Nr.' v-slot="props")
            | \#{{props.row.contractId}}
          b-table-column(field="bookingStatus" label='R/V' v-slot="props")
            | {{props.row.bookingStatus}}
          b-table-column(field="bookingCreatedAt" label='B.-datum' v-slot="props")
            | {{formatDate(props.row.bookingCreatedAt)}}
          b-table-column(field="guestName" label='Gastname' v-slot="props")
            | {{props.row.guestName}}
          b-table-column(label='Zeitraum' v-slot="props" width="180")
            | {{formatDate(props.row.bookingStartDate)}} - {{formatDate(props.row.bookingEndDate)}}
          b-table-column(field="nightCount" label='ÜN' v-slot="props")
            | {{props.row.nightCount}}
          b-table-column(field="commissionPercentage" label='Prov.' v-slot="props")
            | {{props.row.commissionPercentage}}%
          b-table-column(field="taxPercentage" label='MwSt.' v-slot="props")
            | {{props.row.taxPercentage}}%
          b-table-column(field="grossRevenue" label='Miete Eingang' v-slot="props" numeric)
            | {{props.row.grossRevenue / 100 | toCurrency}}
          b-table-column(field="totalCommission" label='abzgl. Prov.' v-slot="props" numeric)
            | {{(props.row.totalCommission + props.row.totalCommissionTax) / 100 | toCurrency}}
          b-table-column(field="netRevenue" label='Miete Ausgang' v-slot="props" numeric)
            | {{props.row.netRevenue / 100 | toCurrency}}
          template(#footer)
            th
              .th-wrap Summe 
            th
              .th-wrap
            th
              .th-wrap
            th
              .th-wrap
            th
              .th-wrap
            th
              .th-wrap
            th
              .th-wrap {{rentObjectData.nightCount}}
            th
              .th-wrap
            th
              .th-wrap
            th
              .th-wrap.is-numeric {{rentObjectData.grossRevenue/100 | toCurrency}}
            th
              .th-wrap.is-numeric {{(rentObjectData.totalCommission + rentObjectData.totalCommissionTax)/100 | toCurrency}}
            th
              .th-wrap.is-numeric {{rentObjectData.netRevenue/100 | toCurrency}}

</template>

<script>
import { DateTime } from 'luxon';
import * as ExcelJS from 'exceljs';

export default {
  data() {
    return {
      rentObjectId: null,
      rootYear: new Date().getFullYear()-10,
      currentYear: new Date().getFullYear(),
      year: new Date().getFullYear(),
      currentMonth: new Date().getMonth(),
      month: -1,
      rentObjectData: [],
      months: [
        "Januar",
        "Februar",
        "März",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
      ]
    };
  },
  computed: {
    rentObjects() {
      return this.$store.state.rentObjects.all;
    },
    sumData() {
      let contractCountSum = 0;
      let nightCountSum = 0;
      let blockedCountSum = 0;
      let grossRevenueSum = 0;
      let totalCommissionSum = 0;
      let totalCommissionTaxSum = 0;
      let netRevenueSum = 0;
      this.rentObjectData.forEach(o => {
        contractCountSum += o.contractCount;
        nightCountSum += o.nightCount;
        blockedCountSum += o.blockedCount;
        grossRevenueSum += o.grossRevenue;
        totalCommissionSum += o.totalCommission;
        totalCommissionTaxSum += o.totalCommissionTax;
        netRevenueSum += o.netRevenue;
      });
      return {contractCountSum, nightCountSum, blockedCountSum, grossRevenueSum, totalCommissionSum, totalCommissionTaxSum, netRevenueSum}
    }
  },
  watch: {
    async rentObjectId() {
      this.rentObjectData = await this.$store.dispatch("rentObjects/statistics", {id: this.rentObjectId, year: this.year, month: this.month});
    },
    async year() {
      this.rentObjectData = await this.$store.dispatch("rentObjects/statistics", {id: this.rentObjectId, year: this.year, month: this.month});
    },
    async month() {
      this.rentObjectData = await this.$store.dispatch("rentObjects/statistics", {id: this.rentObjectId, year: this.year, month: this.month});
    },
  },
  async mounted() {
    this.$store.dispatch("rentObjects/findAll");
  },
  methods: {
    formatDate(d) {
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yy")
    },
    formatDateTime(d) {
      if (d instanceof Date) {
        const dt = DateTime.fromJSDate(d);
        return dt.setLocale('de')
          .toFormat("dd.LL.yyyy")  
      }
      const dt = DateTime.fromISO(d);
      return dt.setLocale('de')
        .toFormat("dd.LL.yyyy")
    },
    toCurrency(value) {
      if (typeof value !== "number") {
          return value;
      }
      var formatter = new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: 'EUR',
          minimumFractionDigits: 2
      });
      return formatter.format(value);
    },
    createExcel() {
      const wb = new ExcelJS.Workbook();

      let rootWs =  wb.addWorksheet('Buchungsübersicht', {
        pageSetup:{
          paperSize: 9,
          orientation:'landscape',
          horizontalCentered: true,
          margins: {
            left: 0.2, right: 0.2,
            top: 0.2, bottom: 0.2,
            header: 0.1, footer: 0.1
          }
        }
      });
      this.generateWorksheet(rootWs, this.rentObjectData, 'Buchungsübersicht für '+this.rentObjects.find(r => r.id === this.rentObjectId).name + '     ' + this.year);

      const self = this;
      wb.xlsx.writeBuffer( {
          base64: true
      })
      .then( function (xls64) {
          // build anchor tag and attach file (works in chrome)
          var a = document.createElement("a");
          var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

          var url = URL.createObjectURL(data);
          a.href = url;
          a.download = `Buchungsübersicht_${self.rentObjects.find(r => r.id === self.rentObjectId).code}_${self.year}.xlsx`;
          document.body.appendChild(a);
          a.click();
          setTimeout(function() {
                  document.body.removeChild(a);
                  window.URL.revokeObjectURL(url);
              },
              0);
      })
      .catch(function(error) {
          console.log(error.message);
      });
    },
    generateWorksheet(ws, values, name) {
      const fontOptions = {
         name: 'Arial',
         size: 9
      };
      const columns = [
        { header: 'Pos.', key: 'nr', width: 4, style: { font: fontOptions}},
        { header: 'V.-Nr.', key: 'contractId', width: 6, style: { font: fontOptions}},
        { header: 'R/V', key: 'rv', width: 4, style: { font: fontOptions}},
        { header: 'B.-datum', key: 'bookingDate', width: 8, style: { font: fontOptions}},
        { header: 'Gastname', key: 'guestName', width: 18, style: { font: fontOptions}},
        { header: 'Zeitraum', key: 'dateRange', width: 16, style: { font: fontOptions}},
        { header: 'ÜN', key: 'nights', width: 4, style: { font: fontOptions}},
        { header: 'Miete Eingang', key: 'gross', width: 12, style: { font: fontOptions}},
        { header: 'Prov. %', key: 'commissionPercentage', width: 8, style: { font: fontOptions}}, // prov. netto
        { header: 'Prov. netto', key: 'commissionNet', width: 10, style: { font: fontOptions}},
        { header: 'MwSt. %', key: 'taxP', width: 8, style: { font: fontOptions}},
        { header: 'MwSt.', key: 'tax', width: 8, style: { font: fontOptions}},
        { header: 'Prov. gesamt', key: 'minus', width: 10, style: { font: fontOptions}},
        { header: 'Miete Ausgang', key: 'net', width: 16, style: { font: fontOptions}}
      ];
      const border = {
        top: {style:'thin', color: {argb:'FFAAAAAA'}},
        left: {style:'thin', color: {argb:'FFAAAAAA'}},
        bottom: {style:'thin', color: {argb:'FFAAAAAA'}},
        right: {style:'thin', color: {argb:'FFAAAAAA'}}
      };
      ws.columns = columns;
      
      const rowOffset = 3;
      ws.duplicateRow(1, 2, true);
      ws.getRow(1).values = [name];
      ws.getRow(1).height = 25;
      ws.mergeCells('A1:N1');
      ws.getCell('A1').fill = { type: 'pattern', pattern: 'solid', fgColor: { argb:'FFe3f4ff' }}

      ws.getRow(2).values = [''];
      ws.getCell('A2').value = `Eigentümer: ${this.rentObjectData.owner.fullName}`;
      ws.getCell('F2').value = `${parseInt(this.month) === -1 ? 'Gesamt' : this.months[this.month]} ${this.year}`;
      ws.getCell('N2').value = `erstellt am: ${this.formatDateTime(new Date())}`;
      ws.getCell('N2').alignment = { vertical: 'middle', horizontal: 'right' };
      ws.pageSetup.printTitlesColumn = 'A:N';
      ws.pageSetup.printTitlesRow = '1:3';

      // Here we add the data
      let totalNights = 0;
      let totalGross = 0;
      let totalNet = 0;
      let totalCommission = 0;
      let totalCommissionTax = 0;
      for (let i = 0; i < values.contracts.length; i+= 1) {
        const a = values.contracts[i];
        ws.insertRow(i+rowOffset+1, [
          i+1,
          a.contractId,
          a.bookingStatus,
          this.formatDate(a.bookingCreatedAt),
          a.guestName,
          `${this.formatDate(a.bookingStartDate)} - ${this.formatDate(a.bookingEndDate)}`,
          a.nightCount,
          a.grossRevenue/100,
          a.commissionPercentage+'%',
          a.totalCommission/100,
          a.taxPercentage+'%',
          a.totalCommissionTax/100,
          (a.totalCommission + a.totalCommissionTax)/100,
          a.netRevenue/100
        ]);

        totalNights += a.nightCount;
        totalGross += a.grossRevenue;
        totalCommission += a.totalCommission;
        totalCommissionTax += a.totalCommissionTax;
        totalNet += a.netRevenue;
      }

      // Summe
      ws.insertRow(values.contracts.length+rowOffset+1, [
        '',
        '',
        '',
        '',
        '',
        '',
        totalNights,
        totalGross/100,
        '',
        totalCommission/100,
        '',
        totalCommissionTax/100,
        (totalCommission + totalCommissionTax)/100,
        totalNet/100
      ]);
      ws.getRow(values.contracts.length+rowOffset+1).font = { ...fontOptions, bold: true };

      // Summe
      ws.insertRow(values.contracts.length+rowOffset+3, [
        'Miete Eingang',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        totalGross/100
      ]);
      ws.mergeCells(`A${values.contracts.length+rowOffset+3}:K${values.contracts.length+rowOffset+3}`);
      ws.getCell(`N${values.contracts.length+rowOffset+3}`).font = { ...fontOptions, bold: true };

      // Summe
      ws.insertRow(values.contracts.length+rowOffset+4, [
        `abzgl. Provision ${this.toCurrency(totalCommission / 100)} netto zzgl. 19 % MwSt. ${this.toCurrency(totalCommissionTax / 100)}`,
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        (totalCommission + totalCommissionTax) / 100 * -1
      ]);
      ws.mergeCells(`A${values.contracts.length+rowOffset+4}:K${values.contracts.length+rowOffset+4}`);
      ws.getCell(`N${values.contracts.length+rowOffset+4}`).font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };

      // Summe
      ws.insertRow(values.contracts.length+rowOffset+5, [
        'Miete Ausgang',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        totalNet/100
      ]);
      ws.mergeCells(`A${values.contracts.length+rowOffset+5}:K${values.contracts.length+rowOffset+5}`);
      ws.getCell(`N${values.contracts.length+rowOffset+5}`).font = { ...fontOptions, bold: true };

      // Custom Color Styles
      // ws.getColumn('isChange').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      // ws.getColumn('bw').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      // ws.getColumn('ht').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      // ws.getColumn('kb').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      // ws.getColumn('kh').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      // ws.getColumn('paymentLeft').font = { ...fontOptions, bold: true, color: { argb: 'FFFF0000' } };
      ws.getRow(1).font = { ...fontOptions, bold: true, color: { argb: 'FF000000' }, size: 14 };
      ws.getRow(2).font = { ...fontOptions, bold: true, color: { argb: 'FF000000' } };
      ws.getRow(3).font = { ...fontOptions, bold: true };

      // Here we align everything and calculate row height
      ws.eachRow(function (row, rowNr) {
        if (rowNr <= 2) return;
        row.eachCell(function (cell) {
            cell.alignment = { vertical: 'middle', horizontal: 'center' };
            cell.border = border;
            if (4 <= rowNr && rowNr < values.contracts.length+rowOffset+1 && rowNr % 2 === 0) {
              cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb:'FFe3f4ff' }}
            }
        });
        if (rowNr >= 4) {
          row.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
          row.height = 16;
        }
      });

      // Custom Alignment Styles
      // ws.getColumn('lastName').alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
      // ws.getColumn('infos').alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
      // ws.getColumn('totalPrice').alignment = { vertical: 'middle', horizontal: 'right' };
      ws.getColumn('gross').alignment = { vertical: 'middle', horizontal: 'right' };
      ws.getColumn('minus').alignment = { vertical: 'middle', horizontal: 'right' };
      ws.getColumn('net').alignment = { vertical: 'middle', horizontal: 'right' };

      ws.getColumn('gross').numFmt = '#,##0.00 €';
      ws.getColumn('commissionNet').numFmt = '#,##0.00 €';
      ws.getColumn('tax').numFmt = '#,##0.00 €';
      ws.getColumn('minus').numFmt = '#,##0.00 €';
      ws.getColumn('net').numFmt = '#,##0.00 €';
      
      ws.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };
      ws.getRow(3).alignment = { vertical: 'middle', horizontal: 'center' };
      
      ws.getCell(`A${values.contracts.length+rowOffset+3}`).alignment = { vertical: 'middle', horizontal: 'left' };
      ws.getCell(`A${values.contracts.length+rowOffset+4}`).alignment = { vertical: 'middle', horizontal: 'left' };
      ws.getCell(`A${values.contracts.length+rowOffset+5}`).alignment = { vertical: 'middle', horizontal: 'left' };
      ws.getCell(`N${values.contracts.length+rowOffset+3}`).alignment = { vertical: 'middle', horizontal: 'right' };
      ws.getCell(`N${values.contracts.length+rowOffset+4}`).alignment = { vertical: 'middle', horizontal: 'right' };
      ws.getCell(`N${values.contracts.length+rowOffset+5}`).alignment = { vertical: 'middle', horizontal: 'right' };

      ws.autoFilter = `A$${rowOffset}:N${rowOffset+values.length}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-text {
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.extra-table {
  font-size: 0.8rem;
  td {
    padding: 0;
  }
}
</style>